var _mask, _path, _path2, _rect, _circle, _circle2, _circle3, _circle4, _rect2, _rect3, _rect4, _g, _rect5, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 178,
    viewBox: "0 0 387 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_930_219",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.742 52.2202C116.742 47.608 120.481 43.8691 125.093 43.8691H188.106C192.718 43.8691 196.457 47.608 196.457 52.2202V54.5506C195.534 55.2926 194.938 56.4743 194.938 57.8054C194.938 59.1364 195.534 60.3181 196.457 61.0601V109.213C195.534 109.955 194.938 111.136 194.938 112.467C194.938 113.799 195.534 114.98 196.457 115.722V122.825C196.457 127.437 192.718 131.176 188.106 131.176H125.093C120.481 131.176 116.742 127.437 116.742 122.825V115.724C117.666 114.982 118.264 113.8 118.264 112.467C118.264 111.135 117.666 109.953 116.742 109.211V61.0619C117.666 60.32 118.264 59.1375 118.264 57.8054C118.264 56.4732 117.666 55.2907 116.742 54.5488V52.2202Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.742 52.2202C116.742 47.608 120.481 43.8691 125.093 43.8691H188.106C192.718 43.8691 196.457 47.608 196.457 52.2202V54.5506C195.534 55.2926 194.938 56.4743 194.938 57.8054C194.938 59.1364 195.534 60.3181 196.457 61.0601V109.213C195.534 109.955 194.938 111.136 194.938 112.467C194.938 113.799 195.534 114.98 196.457 115.722V122.825C196.457 127.437 192.718 131.176 188.106 131.176H125.093C120.481 131.176 116.742 127.437 116.742 122.825V115.724C117.666 114.982 118.264 113.8 118.264 112.467C118.264 111.135 117.666 109.953 116.742 109.211V61.0619C117.666 60.32 118.264 59.1375 118.264 57.8054C118.264 56.4732 117.666 55.2907 116.742 54.5488V52.2202Z",
    fill: "#120C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.457 54.5506L196.933 55.1422L197.216 54.9143V54.5506H196.457ZM196.457 61.0601H197.216V60.6964L196.933 60.4685L196.457 61.0601ZM196.457 109.213L196.933 109.804L197.216 109.576V109.213H196.457ZM196.457 115.722H197.216V115.359L196.933 115.131L196.457 115.722ZM116.742 115.724L116.267 115.132L115.983 115.36V115.724H116.742ZM116.742 109.211H115.983V109.575L116.267 109.803L116.742 109.211ZM116.742 61.0619L116.267 60.4699L115.983 60.6978V61.0619H116.742ZM116.742 54.5488H115.983V54.9129L116.267 55.1408L116.742 54.5488ZM125.093 43.11C120.062 43.11 115.983 47.1888 115.983 52.2202H117.501C117.501 48.0273 120.9 44.6283 125.093 44.6283V43.11ZM188.106 43.11H125.093V44.6283H188.106V43.11ZM197.216 52.2202C197.216 47.1887 193.137 43.11 188.106 43.11V44.6283C192.299 44.6283 195.698 48.0273 195.698 52.2202H197.216ZM197.216 54.5506V52.2202H195.698V54.5506H197.216ZM195.697 57.8054C195.697 56.7024 196.191 55.7389 196.933 55.1422L195.981 53.9591C194.878 54.8463 194.178 56.2462 194.178 57.8054H195.697ZM196.933 60.4685C196.191 59.8718 195.697 58.9083 195.697 57.8054H194.178C194.178 59.3645 194.878 60.7644 195.981 61.6517L196.933 60.4685ZM197.216 109.213V61.0601H195.698V109.213H197.216ZM195.697 112.467C195.697 111.364 196.191 110.401 196.933 109.804L195.981 108.621C194.878 109.508 194.178 110.908 194.178 112.467H195.697ZM196.933 115.131C196.191 114.534 195.697 113.57 195.697 112.467H194.178C194.178 114.027 194.878 115.427 195.981 116.314L196.933 115.131ZM197.216 122.825V115.722H195.698V122.825H197.216ZM188.106 131.935C193.137 131.935 197.216 127.856 197.216 122.825H195.698C195.698 127.017 192.299 130.416 188.106 130.416V131.935ZM125.093 131.935H188.106V130.416H125.093V131.935ZM115.983 122.825C115.983 127.856 120.062 131.935 125.093 131.935V130.416C120.9 130.416 117.501 127.017 117.501 122.825H115.983ZM115.983 115.724V122.825H117.501V115.724H115.983ZM117.505 112.467C117.505 113.571 117.01 114.535 116.267 115.132L117.218 116.316C118.322 115.429 119.023 114.028 119.023 112.467H117.505ZM116.267 109.803C117.01 110.399 117.505 111.364 117.505 112.467H119.023C119.023 110.907 118.322 109.506 117.218 108.619L116.267 109.803ZM115.983 61.0619V109.211H117.501V61.0619H115.983ZM117.505 57.8054C117.505 58.9092 117.01 59.8734 116.267 60.4699L117.218 61.6538C118.322 60.7667 119.023 59.3657 119.023 57.8054H117.505ZM116.267 55.1408C117.01 55.7374 117.505 56.7015 117.505 57.8054H119.023C119.023 56.245 118.322 54.844 117.218 53.9569L116.267 55.1408ZM115.983 52.2202V54.5488H117.501V52.2202H115.983Z",
    fill: "url(#paint0_linear_930_219)",
    fillOpacity: 0.5,
    mask: "url(#path-1-inside-1_930_219)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.375,
    y: 56.7754,
    width: 59.2166,
    height: 60.7349,
    rx: 3.79593,
    fill: "#322900"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 131.925,
    cy: 62.0897,
    r: 1.51837,
    fill: "#F9B63E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 131.925,
    cy: 111.436,
    r: 1.51837,
    fill: "#F9B63E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 182.792,
    cy: 111.436,
    r: 1.51837,
    fill: "#F9B63E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 182.792,
    cy: 62.0897,
    r: 1.51837,
    fill: "#F9B63E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 147.109,
    y: 61.3301,
    width: 20.498,
    height: 2.27756,
    rx: 1.13878,
    fill: "#F9B63E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 147.109,
    y: 109.918,
    width: 20.498,
    height: 2.27756,
    rx: 1.13878,
    fill: "#F9B63E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.242,
    y: 78.0322,
    width: 39.4777,
    height: 14.4246,
    rx: 0.759187,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.758,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.87,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.983,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.096,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.208,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.321,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.434,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.547,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.659,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.771,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.885,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.997,
    y: 79.5508,
    width: 1.51837,
    height: 11.3878,
    rx: 0.227756,
    fill: "#FDCE47"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103.837,
    y: 34.7592,
    width: 105.527,
    height: 105.527,
    rx: 9.86943,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1.51837
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.4912H103",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1.36737
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 58,
    width: 103,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.4912H103",
    stroke: "white",
    strokeWidth: 1.36737
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36.0273,
    y: 11.6328,
    width: 24.9415,
    height: 90.2463,
    fill: "#E3AE24"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.8994H103",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 1.36737
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 75,
    width: 103,
    height: 2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.8994H103",
    stroke: "white",
    strokeWidth: 1.36737
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36.0273,
    y: 28.041,
    width: 24.9415,
    height: 90.2463,
    fill: "#E3AE24"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 92.3076H103",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 1.36737
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 91,
    width: 103,
    height: 2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 92.3076H103",
    stroke: "white",
    strokeWidth: 1.36737
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36.0273,
    y: 44.4492,
    width: 24.9415,
    height: 90.2463,
    fill: "#E3AE24"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.717H103",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 1.36737
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 108,
    width: 103,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.717H103",
    stroke: "white",
    strokeWidth: 1.36737
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36.0273,
    y: 60.8594,
    width: 24.9415,
    height: 90.2463,
    fill: "#E3AE24"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 125.125H103",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 1.36737
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 124,
    width: 103,
    height: 2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 125.125H103",
    stroke: "white",
    strokeWidth: 1.36737
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -36.0273,
    y: 77.2676,
    width: 24.9415,
    height: 90.2463,
    fill: "#E3AE24"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.477 65.6452H240.853C258.42 65.6452 275.021 57.6049 285.912 43.8215L301.665 23.8861C312.556 10.1028 329.157 2.0625 346.725 2.0625H386.216",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 0,
    width: 170,
    height: 68
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.953 65.6452H241.329C258.896 65.6452 275.497 57.6049 286.389 43.8215L302.142 23.8861C313.033 10.1028 329.634 2.0625 347.201 2.0625H386.693",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.983,
    y: -64.9385,
    width: 25.5953,
    height: 176.391,
    fill: "#E3AE24"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.477 89.5739H240.853C258.42 89.5739 275.021 81.5336 285.912 67.7502L301.665 47.8148C312.556 34.0315 329.157 25.9912 346.725 25.9912H386.216",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 25,
    width: 169,
    height: 67
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M217 90.2575H240.376C257.943 90.2575 274.544 82.2172 285.436 68.4338L301.188 48.4984C312.08 34.7151 328.681 26.6748 346.248 26.6748H385.74",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.03,
    y: -40.3262,
    width: 25.5953,
    height: 176.391,
    fill: "#E3AE24"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M217.477 113.504H240.853C258.42 113.504 275.021 105.463 285.912 91.6799L301.665 71.7445C312.556 57.9612 329.157 49.9209 346.725 49.9209H386.216",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 48,
    width: 169,
    height: 67
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217 113.504H240.376C257.943 113.504 274.544 105.463 285.436 91.6799L301.188 71.7445C312.08 57.9612 328.681 49.9209 346.248 49.9209H385.74",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.03,
    y: -17.0801,
    width: 25.5953,
    height: 176.391,
    fill: "#E3AE24"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 128.545H363.312C345.744 128.545 329.143 120.504 318.252 106.721L302.499 86.7855C291.608 73.0022 275.007 64.9619 257.439 64.9619H217.948",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 63,
    width: 170,
    height: 67
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.685 128.545H363.309C345.741 128.545 329.141 120.504 318.249 106.721L302.496 86.7855C291.605 73.0022 275.004 64.9619 257.437 64.9619H217.945",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.976,
    y: -23.917,
    width: 25.5953,
    height: 233.82,
    fill: "#E3AE24"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 152.473H363.312C345.744 152.473 329.143 144.433 318.252 130.65L302.499 110.714C291.608 96.9309 275.007 88.8906 257.439 88.8906H217.948",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 86,
    width: 170,
    height: 68
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M386.685 151.79H363.309C345.741 151.79 329.141 143.749 318.249 129.966L302.496 110.031C291.605 96.2473 275.004 88.207 257.437 88.207H217.945",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.976,
    y: -0.671875,
    width: 25.5953,
    height: 233.82,
    fill: "#E3AE24"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 176.402H363.312C345.744 176.402 329.143 168.362 318.252 154.578L302.499 134.643C291.608 120.86 275.007 112.819 257.439 112.819H217.948",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 2.73474
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_930_219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 111,
    width: 170,
    height: 67
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M386.685 176.402H363.309C345.741 176.402 329.141 168.362 318.249 154.578L302.496 134.643C291.605 120.86 275.004 112.819 257.437 112.819H217.945",
    stroke: "white",
    strokeWidth: 2.73474
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_930_219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_930_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.976,
    y: 23.9404,
    width: 25.5953,
    height: 233.82,
    fill: "#E3AE24"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_930_219",
    x: -52.9827,
    y: -5.32256,
    width: 58.8522,
    height: 124.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_930_219",
    x: -52.9827,
    y: 11.0856,
    width: 58.8522,
    height: 124.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_930_219",
    x: -52.9827,
    y: 27.4938,
    width: 58.8522,
    height: 124.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_930_219",
    x: -52.9827,
    y: 43.904,
    width: 58.8522,
    height: 124.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_930_219",
    x: -52.9827,
    y: 60.3122,
    width: 58.8522,
    height: 124.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_930_219",
    x: 164.028,
    y: -81.8939,
    width: 59.5065,
    height: 210.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_930_219",
    x: 163.075,
    y: -57.2815,
    width: 59.5065,
    height: 210.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_930_219",
    x: 163.075,
    y: -34.0355,
    width: 59.5065,
    height: 210.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_930_219",
    x: 164.02,
    y: -40.8724,
    width: 59.5065,
    height: 267.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_930_219",
    x: 164.02,
    y: -17.6272,
    width: 59.5065,
    height: 267.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_930_219",
    x: 164.02,
    y: 6.98506,
    width: 59.5065,
    height: 267.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47769,
    result: "effect1_foregroundBlur_930_219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_930_219",
    x1: 122.056,
    y1: 43.8691,
    x2: 204.808,
    y2: 151.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.9eb6a56244192d8fd03c62a9aed918b5.svg";
export { ForwardRef as ReactComponent };